<template>
  <div slot="item" ref="root" class="dh-psy-carousel">
    <div :class="{
        'carousel-cell': true,
        'nrk-sr': !ready && idx > 0,
        'carousel-cell--43': image.aspect === '4:3',
        'carousel-cell--34': image.aspect === '3:4',
        'carousel-cell--163': image.aspect === '16:3',
        'carousel-cell--11': image.aspect === '1:1',
        'carousel-cell--169': !image.aspect || image.aspect === '16:9',
      }" v-for="(image, idx) in imageSrc" :key="image + idx">
      <Esi :src="`${image.src}&size=10${image.caption ? `&caption=${image.caption}` : ''}`" />
    </div>
  </div>
</template>

<script>
import './Slider.css'
import Esi from '../../Utilities/Esi.vue'
import { getSerumImageUrl } from '../../../helpers/serum-helpers.js'
import globalEventStore from '../../../lib/global-event-store'

export default {
  props: {
    imageIds: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    Esi
  },
  mounted() {
    import('flickity')
      .then(({ default: flickity }) => {
        this.flickity = flickity
        this.ready = true
        return flickity
      })
      .then(this.mountFlickity)
  },
  data() {
    return {
      ready: false,
      index: 0,
      centered: false,
      flickityOptions: {
        dragThreshold: 1,
        adaptiveHeight: true,
        wrapAround: false,
        percentPosition: false,
        cellAlign: 'center',
        arrowShape: `M73.3,100c-1,0-2-0.4-2.7-1.1L21.7,50L70.5,1.2c1.5-1.5,3.9-1.5,5.4,0c1.5,1.5,1.5,3.9,0,5.4L32.6,50L76,93.4 c1.5,1.5,1.5,3.9,0,5.4C75.2,99.6,74.2,100,73.3,100z`
      }
    }
  },
  computed: {
    imageSrc() {
      return this.imageIds.map(image => {
        const { id, aspect } = image.value
        return {
          id,
          aspect,
          src: getSerumImageUrl(id, aspect, '12')
        }
      })
    }
  },
  methods: {
    preventScroll(e) {
      e = e || window.event
      if (e.preventDefault) e.preventDefault()
      e.returnValue = false

      e.preventDefault()
    },
    mountFlickity(Flickity) {
      function scrollFix(e) {
        e.preventDefault()
      }
      this.flickityInstance = new Flickity(this.$refs.root, {
        ...this.flickityOptions,
        on: {
          dragStart(event, pointer) {
            document.ontouchmove = scrollFix
          },
          dragEnd(e) {
            document.ontouchmove = function(e) {
              return true
            }
          },
          change: this.handleChange
        }
      })
    },
    handleChange(index) {
      globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
        action: `CAROUSEL_CHANGE/${index}/${this.imageSrc[index].id}`
      })
    }
  }
}
</script>

<style scoped lang="postcss">
  :root {
    --dh-psy-carousel--margin: 150px;
  }

  .dh-psy-carousel {
    position: relative;
    margin: 0px auto 50px;
    transition: height 0.2s ease-in-out;
    padding: 20px 0;
    width: 95vw;
    box-sizing: border-box;

    @media (min-width: 800px) {
      max-width: calc(100vw);
    }

    @media (min-width: 1200px) {
      max-width: 0vw;
    }

    @media (min-width: 1350px) {
      max-width: 85vw;
    }

    @media (min-width: 1750px) {
      max-width: 1450px;
    }

    & .carousel-cell {
      width: 90%;

      display: flex;
      justify-content: center;
      align-items: center;

      & > * {
        display: flex;
        justify-content: center;
        align-items: center;
        width: auto;
        height: calc(100% - 150px);

        & :global(figure) {
          width: 100%;
        }
      }

      width: 75vw;
      height: calc(75vw + (var(--dh-psy-carousel--margin) / 2));
      margin: 0 2px;

      @media (min-width: 800px) {
        width: 60vw;
        height: calc(60vw + var(--dh-psy-carousel--margin));
        margin: 0 5px;
      }

      @media (min-width: 1200px) {
        width: 45vw;
        height: calc(45vw + var(--dh-psy-carousel--margin));
      }

      @media (min-width: 1550px) {
        width: 45vw;
        height: calc(45vw + var(--dh-psy-carousel--margin));
        margin: 0 5px;
      }

      @media (min-width: 1750px) {
        width: 750px;
        height: calc(750px + var(--dh-psy-carousel--margin));
      }

      &.carousel-cell--11 {
        & > * {
          width: 100%;
        }
      }
    }
  }
</style>
